import { Box, Divider, Grid2, Typography } from '@mui/material'
import React from 'react'
import { CustomBadge } from '../../utils/Badge'
import { AvatarCollabs } from '../../utils/AvatarCollabs'
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import { TextSkeleton } from '../../utils/SkeletonCom';

export const StudentCount = ({count,isLoading,text}) => {
    return (
        <Grid2  children size={{ xs: 12, sm:8}} >
            <Box sx={{ display: "flex", gap: 4, mb: 3, justifyContent: "space-around" }}>
                <Typography variant='h5'> {text}</Typography>
                <CustomBadge icon={<PeopleOutlineIcon />} />
            </Box>
            <Box sx={{ display: "flex", gap: 5, alignItems: "start", justifyContent: "space-around" }}>
                <Box>
                    <Typography variant='h6' color='blue.main'>tap to know more</Typography>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                        {
                            isLoading && <TextSkeleton/>
                        }
                        {
                            !isLoading &&  <Typography variant='h2'>{count}</Typography>
                        }
                       
                        <AvatarCollabs />
                    </Box>
                </Box>
                <CustomBadge bgcolor={"#E2FFDD"} icon={<TrendingUpIcon sx={{ color: "#00BF59" }} />} />
            </Box>
        </Grid2>
    )
}
